// @flow
import React from "react";
import styled, { css } from "styled-components";
import { Link as RawLink } from "../common/Link";

import type { Node } from "react";

const LinkContainer = styled.div`
  margin-top: 15px;
  align-self: center;
  text-align: center;
`;

const LinkView = styled(RawLink)`
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: ${({ theme }) => theme.alternativeAccent};
  text-decoration: underline;

  ${({ theme }) =>
    theme.direction === "rtl" &&
    css`
      font-size: 16px;
    `};

  :hover,
  :focus,
  :active {
    text-decoration: none;
  }
`;

const LinkButton = styled.button`
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: ${({ theme }) => theme.accent};
  text-decoration: underline;
  background: transparent;
  border: none;
  border-radius: none;
  appearance: none;
  cursor: pointer;

  ${({ theme }) =>
    theme.direction === "rtl" &&
    css`
      font-size: 16px;
    `};

  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.accent};
    text-decoration: none;
  }
`;

type Props = {
  to?: string,
  onClick?: () => void,
  children: Node
};

function Link({ to, onClick, children, ...props }: Props) {
  const LinkComponent = to !== undefined ? LinkView : LinkButton;

  return (
    <LinkContainer {...props}>
      <LinkComponent to={to} onClick={onClick} target={props.target || "_blank"}>
        {children}
      </LinkComponent>
    </LinkContainer>
  );
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Link.js